<template>
  <div class="container mx-auto px-4 py-8">
    <h1 class="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-8 text-center text-primary">
      {{ t("ui.title") }}
    </h1>

    <StepperHeader
      :sections="navSections"
      :currentIndex="formStore.currentSectionIndex"
      :completedIndices="completedSectionIndices"
      @navigate="navigateToSection" />

    <div v-if="!isSummaryStep">
      <ProgressBar :progress="scoreStore.progress" :currentStep="currentStep" :totalSteps="totalSteps" />
      <QuestionForm :section="activeSection" />
    </div>

    <div v-else>
      <BlueprintSummary :answers="formStore.answers" :schema="questionSchema" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useFormStore } from "@/features/blueprint/stores/useFormStore";
import { useScoreStore } from "@/features/blueprint/stores/useScoreStore";
import { useBlueprintState } from "@/features/blueprint/composables/useBlueprintState";
import { useBlueprintNavigation } from "@/features/blueprint/composables/useBlueprintNavigation";
import { useBlueprintLifecycle } from "@/features/blueprint/composables/useBlueprintLifecycle";
import QuestionForm from "@/features/blueprint/components/questions/QuestionForm.vue";
import ProgressBar from "@/features/blueprint/components/progress/ProgressBar.vue";
import BlueprintSummary from "@/features/blueprint/components/summary/BlueprintSummary.vue";
import StepperHeader from "@/features/blueprint/components/progress/StepperHeader.vue";

const { t } = useI18n();
const formStore = useFormStore();
const scoreStore = useScoreStore();

const { questionSchema, navSections, currentStep, totalSteps, completedSectionIndices, isSummaryStep, activeSection } =
  useBlueprintState(t);

const { navigateToSection } = useBlueprintNavigation(formStore);

onMounted(() => {
  useBlueprintLifecycle({ formStore, scoreStore, questionSchema: questionSchema });
});
</script>
